// client/src/components/Admin/Dashboard/_shared/MonthlyMiniLineChart.js
//
// M06 Fase 6/7 - Grafica linea simple mensual. Recibe `data` con
// [{ month, count }] o multiples series con `series=[{name, data:[{month,count}]}]`.

import React from "react";
import { Line } from "@ant-design/charts";

const MONTH_LABELS = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

function normalize(rows, name) {
  return (rows || []).map((p, i) => ({
    month:
      typeof p.month === "number"
        ? MONTH_LABELS[(p.month - 1 + 12) % 12] || String(i + 1)
        : p.month || String(i + 1),
    value: Number(p.count ?? p.value ?? 0),
    name,
  }));
}

export function MonthlyMiniLineChart({
  data,
  series,
  height = 240,
  color = "#ed773c",
}) {
  if (series && Array.isArray(series)) {
    const merged = series.flatMap((s) => normalize(s.data, s.name));
    const isEmpty = merged.every((p) => p.value === 0);
    if (isEmpty) {
      return (
        <div
          style={{
            padding: 24,
            textAlign: "center",
            color: "rgba(0,0,0,0.45)",
            fontSize: 13,
          }}
        >
          Sin datos en el rango
        </div>
      );
    }
    return (
      <Line
        data={merged}
        xField="month"
        yField="value"
        seriesField="name"
        smooth
        height={height}
        legend={{ position: "top" }}
        point={{ size: 3 }}
      />
    );
  }

  const points = normalize(data, "value");
  if (points.length === 0 || points.every((p) => p.value === 0)) {
    return (
      <div
        style={{
          padding: 24,
          textAlign: "center",
          color: "rgba(0,0,0,0.45)",
          fontSize: 13,
        }}
      >
        Sin datos en el rango
      </div>
    );
  }
  return (
    <Line
      data={points}
      xField="month"
      yField="value"
      smooth
      height={height}
      color={color}
      point={{ size: 3 }}
      legend={false}
    />
  );
}
